<template>
  <div @click="gotoProductDetail()" class="series-item">
    <img :src="info.imageUrl"/>
    <div class="tit">{{ info.name }}</div>
  </div>
</template>

<script>
export default {
  props: {
    info: {},
    productType: "",
  },

  data() {
    return {};
  },
  mounted() {


  },
  methods: {
    gotoProductDetail() {
      let url = './designdetail?id=' + this.info.id

      if( this.info.designCategory == 'LianTou') {
        url = './designltdetail?id=' + this.info.id
      }
      if(this.productType == 'MianLiao') {
        url = './productdetail?id=' + this.info.id
      }
      this.$router.push(url);
    },
  }
};
</script>
<style scoped>
.series-item .tit {
  font-size: 14px;
  padding: 20px;
}

.series-item img {
  max-width: 100%;
}
</style>
